<script setup lang="ts">
const { openLogin } = useAuth();

const redirectToHome = () => {
  navigateTo(localeLink('/'));
  openLogin();
};
</script>

<template>
  <section :class="$style.messageWrapper">
    <img
      alt="Email icon"
      aria-hidden="true"
      :class="$style.icon"
      :src="getAssetsUrlForCDN('/assets/images/svg/success_check.svg')"
    />

    <div :class="$style.textMessage">
      <p>{{ $t('auth.recover_password.success.title') }} </p>
      <span> {{ $t('auth.recover_password.success.subtitle') }} </span>
    </div>

    <button
      :class="$style.btnSubmit"
      type="button"
      @click="redirectToHome"
    >
      <NuxtIcon name="check" />
      {{ $t('auth.recover_password.success.go_to_login') }}
    </button>
  </section>
</template>

<style module lang="scss">
.messageWrapper {
  @apply flex flex-col justify-center items-center space-y-6 my-4;

  .textMessage {
    @apply mt-8 text-center justify-center items-center;

    p {
      @apply text-texts font-semibold;
    }
    span {
      @apply text-texts text-xs;
    }
  }

  .icon {
    @apply w-28 h-28 mx-auto mt-5;
  }

  .btnSubmit {
    @apply bg-button-bg text-button-text py-2 px-4 rounded-md text-sm font-semibold whitespace-nowrap flex items-center justify-center gap-2 disabled:opacity-40 disabled:cursor-not-allowed;
  }
}
</style>
